import React from "react";
import { Route } from "react-router-dom";

const PublicRoute = ({
  publicRoute,
  layout: Layout,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout publicRoute={publicRoute}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default PublicRoute;
